exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".space-between[data-v-f261f3d4]{margin-left:5px;margin-right:5px}", ""]);

// exports
